import {
    SELECT_DESIGN_FOR_FAVOURITE,
    SET_DESIGN_FOR_FAVOURITE,
    UNSELECT_DESIGN_FOR_FAVOURITE
} from '../../@types/thunk.types'
import { ExploreDesignAction } from '../DesignLab/ExploreDesignSlice'
import {
    doFavourite,
    doSoldStyleFavourite,
    undoFavourite
} from '../../../services/v3/Favourite/FavouriteService'
import { DoFavouriteActions } from './index'
import { SET_SELECTED_FAVOURITE } from '../../@types/action.types'
import { getUserPreference } from '../../../helpers/Util'
import { setSoldStyleFavInfo } from '../../Favourite/SoldStyleFavSlice'

export const DoFavouriteThunk = {
    [SELECT_DESIGN_FOR_FAVOURITE]:
        (designInfo, trackId) => async (dispatch) => {
            let folderId = getUserPreference()?.defaultFavouriteFolder?.id
            let params = `?productIds=${designInfo?.id}`
            let soldStyleParams = `?productId=${designInfo?.id}&remarks=Show me some options`
            if (trackId) params += `&tid=${trackId}`
            if (folderId) params += `&folderId=${folderId}`
            dispatch(DoFavouriteActions[SET_SELECTED_FAVOURITE](designInfo))
            const response = designInfo?.isSold
                ? await doSoldStyleFavourite(soldStyleParams)
                : await doFavourite(params)
            if (response?.success && designInfo?.isSold) {
                dispatch(
                    setSoldStyleFavInfo({
                        isOpenSoldStyleChangePopup: true,
                        selectedStyle: designInfo,
                        soldFolderId: response?.payload?.folderId
                    })
                )
            }
            dispatch(
                ExploreDesignAction[SET_DESIGN_FOR_FAVOURITE](designInfo?.id)
            )
        },
    [UNSELECT_DESIGN_FOR_FAVOURITE]: (designInfo) => async (dispatch) => {
        await undoFavourite(designInfo?.id)
        dispatch(ExploreDesignAction[SET_DESIGN_FOR_FAVOURITE](designInfo?.id))
    }
}
